/**
 * The ixListToolbar directive displays the standard (currently abort) and the transcluded buttons.
 * Use the 'hide-abort' attribute to hide the abort-button.
 * In differs from ix-dialog-toolbar in the fact that there is no dirty-check on form to change the label of the abort button.
 *
 * @param back-abort hides the back button
 */
angular.module('impactx.toolbar').directive('ixListToolbar', function() {
    return {
        scope: false,
        restrict: 'E',
        controller: 'ListToolbarCtrl',
        controllerAs: 'listToolbarCtrl',
        templateUrl: 'shared/toolbar/templates/listtoolbar.tmpl.html',
        transclude: true,
        link: function(scope, element, attrs) {
            var hideAbortButton = attrs.hasOwnProperty('hideBack') && attrs.hideBack === 'true';
            if(hideAbortButton) {
                scope.hideBack = true;
            }
        }
    };
});